define('presentation/login/viewModels/closedCannotReactivateViewModel',[
    'businessServices/authentication/authenticationManager',
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/authentication/sessionUserInfo',
    'businessServices/authentication/sessionWorkflowFlags',
    'common/promises/promiseFactory',
    'plugins/router',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _authenticationManager = require('businessServices/authentication/authenticationManager');
        const _router = require('plugins/router');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _sessionUserInfo = require('businessServices/authentication/sessionUserInfo');
        const _sessionWorkflowFlags = require('businessServices/authentication/sessionWorkflowFlags');

        self.isCompositionComplete = ko.observable(false);
        self.firstName = _sessionUserInfo.firstName();

        self.shouldDisplayAgentBypassButton = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.onCancel = () => {
            _authenticationManager.logout()
                .done(() => {
                    _router.navigate(_navigationConfiguration.loginPageUrl);
                });
        };

        self.onAgentBypass = () => {
            _sessionWorkflowFlags.hasBypassedClosedAccount(true);
            _router.navigate(_navigationConfiguration.loginLandingPageUrl);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            return _initialize();
        };

        const _initialize = () => {
            return _promiseFactory.wait();
        };
    };
});
